import ReactMarkdown from "react-markdown";

// Willoah-tuned Markdown renderer. Uses our serif/olive palette.
export default function Markdown({ children, className = "" }) {
  if (!children || !children.trim()) return null;
  return (
    <div className={`willow-md text-[#2A2823]/85 leading-relaxed ${className}`}>
      <ReactMarkdown
        components={{
          h1: (p) => <h2 {...p} className="font-serif-display text-3xl text-[#2A2823] mt-6 mb-3" />,
          h2: (p) => <h3 {...p} className="font-serif-display text-2xl text-[#2A2823] mt-6 mb-3" />,
          h3: (p) => <h4 {...p} className="font-serif-display text-xl text-[#4E5A3D] mt-5 mb-2" />,
          p: (p) => <p {...p} className="my-3 whitespace-pre-wrap" />,
          ul: (p) => <ul {...p} className="list-disc pl-6 my-3 space-y-1.5 marker:text-[#B79256]" />,
          ol: (p) => <ol {...p} className="list-decimal pl-6 my-3 space-y-1.5 marker:text-[#B79256]" />,
          li: (p) => <li {...p} className="pl-1" />,
          a: (p) => <a {...p} className="text-[#4E5A3D] underline decoration-[#B79256]/60 underline-offset-2 hover:decoration-[#4E5A3D]" target="_blank" rel="noopener noreferrer" />,
          strong: (p) => <strong {...p} className="text-[#2A2823] font-semibold" />,
          em: (p) => <em {...p} className="text-[#4E5A3D]" />,
          blockquote: (p) => <blockquote {...p} className="border-l-2 border-[#B79256]/60 pl-4 my-4 text-[#2A2823]/75 italic" />,
          hr: () => <hr className="my-6 border-[#B79256]/30" />,
          code: (p) => <code {...p} className="px-1.5 py-0.5 rounded bg-[#B79256]/15 text-[#4E5A3D] text-sm" />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
